import Client from './HTTPClient';

const campaignPriceTemplatesAPI = {
  list (advertiserId) {
    return Client.post(`/api/clients/${advertiserId}/campaignPriceTemplates`, {});
  }
};

export default campaignPriceTemplatesAPI;
